import { render, staticRenderFns } from "./MultipleBarChart.vue?vue&type=template&id=7313f231&"
import script from "./MultipleBarChart.vue?vue&type=script&lang=js&"
export * from "./MultipleBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports